<app-onb-moldura passo="teste" [estado]="estado" subtitulo="Você pede na sua loja como um cliente e tira o pedido aqui. É o jeito mais rápido de entender como tudo funciona.">

  <ng-container *ngIf="!podeTestar">
    <div class="onb-erro" *ngIf="!temProdutoComPreco">Para fazer o pedido de teste, sua loja precisa de pelo menos um produto com preço.</div>
    <div class="onb-erro" *ngIf="temProdutoComPreco && !temComoReceber">Para fazer o pedido de teste, diga antes como o cliente recebe: entrega, retirada ou os dois.</div>
    <div class="onb-acoes" style="margin-top: 12px">
      <a class="onb-btn onb-btn--pri onb-btn--grande" *ngIf="!temProdutoComPreco" routerLink="/admin/comecar/cardapio">Ir para o cardápio</a>
      <a class="onb-btn onb-btn--pri onb-btn--grande" *ngIf="temProdutoComPreco && !temComoReceber" routerLink="/admin/comecar/loja">Configurar entrega e retirada</a>
    </div>
  </ng-container>

  <ng-container *ngIf="podeTestar">
    <p class="onb-nota pt-pendente" *ngIf="pendentes.length && !pedido">
      <span class="onb-pill onb-pill--aviso">Dá para testar já</span> ainda falta {{ pendentes.join(', ') }}, mas isso não impede o teste.
    </p>

    <!-- 1. esperando o pedido -->
    <ng-container *ngIf="!pedido || pedido.status === 5">
      <div class="pt-cartao">
        <div class="pt-qr">
          <img *ngIf="qr" [src]="qr" alt="QR code do link de teste da sua loja">
          <span *ngIf="!qr" class="pt-qr-vazio"><i class="fas fa-qrcode"></i></span>
        </div>
        <div class="pt-instrucoes">
          <p class="pt-cancelado" *ngIf="pedido?.status === 5">O pedido de teste anterior foi cancelado. Faça outro pelo link abaixo.</p>
          <ol>
            <li><span>1</span><div>Aponte a câmera do celular para o QR ou toque em <b>Abrir minha loja</b>.</div></li>
            <li><span>2</span><div>Escolha qualquer produto e faça o pedido. <b>Ele passa mesmo com a loja fechada</b> e fica marcado como teste.</div></li>
            <li><span>3</span><div>Volte aqui: o pedido chega com som e a gente mostra o que fazer.</div></li>
          </ol>
          <div class="onb-acoes">
            <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="abraLoja()"><i class="fas fa-shopping-bag"></i> Abrir minha loja</button>
            <button type="button" class="onb-btn onb-btn--sec onb-btn--grande" (click)="copie()"><i class="far fa-copy"></i> {{ copiado ? 'Copiado' : 'Copiar link' }}</button>
          </div>
        </div>
      </div>
      <div class="pt-esperando" *ngIf="link">
        <span class="pt-pulso"><i class="fas fa-shopping-bag"></i></span>
        <div><b>Aguardando o seu pedido…</b><span>Esta tela atualiza sozinha. Deixe o som ligado.</span></div>
      </div>
      <p class="onb-nota">O pedido de teste não conta em vendas nem relatórios. Ao concluir, ele sai sozinho.</p>
    </ng-container>

    <!-- 2. tirando o pedido -->
    <ng-container *ngIf="pedido && pedido.status !== 5">
      <div class="pt-pedido">
        <div class="pt-pedido-topo">
          <b>#{{ pedido.codigo }}</b>
          <span class="onb-pill onb-pill--aviso">Teste</span>
          <span class="pt-sp"></span>
          <span class="pt-forma">{{ retirada ? 'Retirada' : 'Entrega' }}</span>
        </div>
        <div class="pt-pedido-corpo">
          <div class="pt-cliente" *ngIf="pedido.contatoNome">{{ pedido.contatoNome }}</div>
          <div class="pt-item" *ngFor="let item of pedido.itens"><span>{{ item.qtde }}× {{ item.descricao }}</span><span>{{ item.total | currency:'BRL' }}</span></div>
          <div class="pt-item pt-taxa" *ngIf="pedido.taxaEntrega"><span>Taxa de entrega</span><span>{{ pedido.taxaEntrega | currency:'BRL' }}</span></div>
          <div class="pt-total"><span>Total</span><span>{{ total | currency:'BRL' }}</span></div>
        </div>
        <div class="pt-linha-tempo">
          <span *ngFor="let e of etapas; let i = index" [class.feita]="i < indiceEtapa || pedido.status === 4" [class.atual]="i === indiceEtapa && pedido.status !== 4">{{ e }}</span>
        </div>
        <div class="pt-acao" *ngIf="guia">
          <div class="pt-guia"><b>{{ guia.titulo }}</b> {{ guia.texto }}</div>
          <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="avance()">
            {{ agindo ? 'Atualizando…' : guia.botao }}
          </button>
        </div>
      </div>

      <div class="pt-festa" *ngIf="pedido.status === 4">
        <span class="onb-ic onb-ic--ok"><i class="fas fa-check"></i></span>
        <div>
          <b>Você tirou seu primeiro pedido.</b>
          <span>É assim com todo pedido: chega com som, você aceita, avisa que saiu e fecha. O cliente acompanha tudo pelo WhatsApp.</span>
          <app-onb-bonus class="pt-bonus" [estado]="estado" formato="final"></app-onb-bonus>
          <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="conclua()">
            {{ concluindo ? 'Concluindo…' : 'Concluir os primeiros passos' }}
          </button>
        </div>
      </div>
      <p class="onb-nota">Esse é o mesmo pedido que aparece na tela <a routerLink="/admin/pedidos">Pedidos</a>, a que você vai usar todo dia.</p>
    </ng-container>

    <div class="onb-erro" *ngIf="erro">{{ erro }}</div>
  </ng-container>
</app-onb-moldura>
